import React from 'react';
import { useI18n, locales } from '../i18n/I18nProvider';

const LanguageSwitcher = ({ compact = false }) => {
  const { locale, setLocale } = useI18n();
  return (
    <div className={`inline-flex items-center border border-gray-200 bg-white p-1 shadow-sm ${compact ? 'rounded-md' : 'rounded-lg'}`} role="group" aria-label="Language">
      <button
        type="button"
        onClick={() => setLocale(locales.EN)}
        aria-pressed={locale === locales.EN}
        className={`px-2.5 py-1 text-xs font-medium rounded ${locale === locales.EN ? 'bg-purple-600 text-white' : 'text-gray-600 hover:bg-gray-100'}`}
      >English</button>
      <button
        type="button"
        onClick={() => setLocale(locales.ZH_CN)}
        aria-pressed={locale === locales.ZH_CN}
        className={`px-2.5 py-1 text-xs font-medium rounded ${locale === locales.ZH_CN ? 'bg-purple-600 text-white' : 'text-gray-600 hover:bg-gray-100'}`}
      >简体中文</button>
    </div>
  );
};

export default LanguageSwitcher;
